module.exports = __webpack_public_path__ + "img/icon_lainxi@2x.43fe8e01.png";